import * as Sentry from '@sentry/vue';
import type { Router } from 'vue-router';

export default defineNuxtPlugin((nuxtApp) => {
    const config = useRuntimeConfig();
    const { vueApp } = nuxtApp;

    const enabled = true;

    Sentry.init({
        enabled: enabled,
        app: [vueApp],
        dsn: config.public.SENTRY_DSN,
        autoSessionTracking: true,
        debug: !!config.public.SENTRY_DEBUG,
        integrations: [
            new Sentry.BrowserTracing({
                routingInstrumentation: Sentry.vueRouterInstrumentation(nuxtApp.$router as Router),
                tracePropagationTargets: [config.public.apiProxy, config.public.apiBase, /^\//]
            }),
            new Sentry.Replay()
        ],
        tracesSampleRate: 1.0,
        replaysOnErrorSampleRate: 1.0,
        environment: process.env.NODE_ENV
    });

    vueApp.mixin(
        Sentry.createTracingMixins({
            trackComponents: true,
            timeout: 2000,
            hooks: ['activate', 'create', 'destroy', 'mount', 'update']
        })
    );

    if (enabled) {
        Sentry.attachErrorHandler(vueApp, {
            logErrors: true,
            attachProps: true,
            trackComponents: true,
            timeout: 2000,
            hooks: ['activate', 'create', 'destroy', 'mount', 'update']
        });
    }

    return {
        provide: {
            sentrySetContext: Sentry.setContext,
            sentrySetUser: Sentry.setUser,
            sentrySetTag: Sentry.setTag,
            sentryAddBreadcrumb: Sentry.addBreadcrumb,
            sentryCaptureException: Sentry.captureException
        }
    };
});
